import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { legalApi } from '../services/api';
import { Card, Spinner, Badge } from '../components/UI';
import { CaretLeft, Shield, Clock } from '@phosphor-icons/react';

export default function LegalPage() {
  const { type } = useParams();
  const navigate = useNavigate();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    legalApi.getPage(type).then(r => setPage(r.data)).catch(() => navigate('/'))
      .finally(() => setLoading(false));
  }, [type, navigate]);

  if (loading) return <div className="flex justify-center py-8"><Spinner size="lg" /></div>;
  if (!page) return null;

  return (
    <div className="space-y-4" data-testid={`legal-page-${type}`}>
      <div className="flex items-center gap-3">
        <button onClick={() => navigate(-1)} className="p-1.5 text-[#666] hover:text-[#1A1F36] hover:bg-[#F0F0F0] rounded-lg">
          <CaretLeft className="w-5 h-5" />
        </button>
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <Shield className="w-5 h-5 text-[#6B7280]" />
            <h1 className="text-2xl font-bold text-[#1A1F36]">{page.title}</h1>
          </div>
          <div className="flex items-center gap-3 mt-1 text-xs text-[#888]">
            <Badge variant="default">v{page.version}</Badge>
            {page.updated_at && (
              <span className="flex items-center gap-1">
                <Clock className="w-3 h-3" /> Updated: {new Date(page.updated_at).toLocaleDateString('en-US')}
              </span>
            )}
          </div>
        </div>
      </div>

      <Card className="p-6 sm:p-8" data-testid="legal-content">
        <div className="prose prose-sm max-w-none text-[#333] leading-relaxed whitespace-pre-wrap">
          {page.content}
        </div>
      </Card>
    </div>
  );
}
